import tr from "./tr.json";
import en from "./en.json";
import es from "./es.json";
import de from "./de.json";
import fr from "./fr.json";
import ar from "./ar.json";

export const SUPPORTED_LANGS = ["tr", "en", "es", "de", "fr", "ar"];
export const DEFAULT_LANG = "tr";
export const RTL_LANGS = new Set(["ar"]);

export const dictionaries = { tr, en, es, de, fr, ar };

export function isSupportedLang(lang) {
  return SUPPORTED_LANGS.includes(lang);
}
